import RequestManager from '../requests/RequestManager';
import PinStatusWithTimerValidationTask from "src/requests/tasks/user/PinStatusWithTimerValidationTask";
import { PinUtil } from '../AAF/Pin/PinUtil'
import channelBlockedUtil from "../utils/ChannelBlockedUtil";
import logger from 'src/utils/logger/logger';

class BlockedChannels {
    constructor() {
        this.data = [];
        this.checkBlockedChannels = this.checkBlockedChannels.bind(this);
        this.channelsRequest = new PinStatusWithTimerValidationTask();
        this.blockedChannels = []
    }

    checkBlockedChannels() {
        return new Promise((resolve, reject) => {
            RequestManager.addRequest(this.channelsRequest).then((resp) => {
                if(!resp.response.errors){
                    PinUtil.handleDataPinCodesSuccess(resp, this.blockedChannels)
                    resolve(this.blockedChannels);
                }
            }).catch((err) => {
                logger.error(err);
                PinUtil.handleDataPinCodesError(this.blockedChannels)
                reject(err);
            });
        });

    }
}

export default BlockedChannels;



// WEBPACK FOOTER //
// ./src/utils/BlockedChannels.js